<template>
  <div>
    <div class="query-container space-between">
      <div>
        <el-form size="small" :inline="true">
          <el-form-item label="统计时间：">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="param.startDate"
              type="date"
              @change="query"
              placeholder="选择日期"
            ></el-date-picker
          ></el-form-item>

          <el-form-item>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="param.endDate"
              type="date"
              @change="query"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="路线：" prop="pathId">
            <el-select v-model="param.pathId" @change="query" style="width: 100%">
              <el-option
                v-for="item in pathOpts"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button style="width: 100px; margin-right: 20px" type="primary" @click="query"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 数据表格 -->
    <div class="table-container" style="margin-top: 20px">
      <el-table
        :data="list"
        border
        stripe
        style="width: 100%"
        max-height="600"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column label="序号" type="index" width="100"></el-table-column>
        <el-table-column sortable prop="driverNo" label="司机编号" align="center"></el-table-column>
        <el-table-column prop="driverName" label="司机姓名" align="center"></el-table-column>
        <el-table-column sortable prop="avgTotalDuration" label="平均总时长(分钟)" align="center">
          <template slot-scope="scope">
            {{ scope.row.avgTotalDuration || 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="avgWaitTime" label="平均等待时间(分钟)" sortable align="center">
          <template slot-scope="scope">
            {{ scope.row.avgWaitTime || 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="k1Delay" label="接人延误(分钟)" sortable align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.k1Delay >= 0 ? '#f56c6c' : '#67c23a' }">
              {{ scope.row.k1Delay >= 0 ? "+" : "" }}{{ scope.row.k1Delay || 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="k2Delay" label="高速延误(分钟)" sortable align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.k2Delay >= 0 ? '#f56c6c' : '#67c23a' }">
              {{ scope.row.k2Delay >= 0 ? "+" : "" }}{{ scope.row.k2Delay || 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="k3Delay" label="送人延误(分钟)" sortable align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.k3Delay >= 0 ? '#f56c6c' : '#67c23a' }">
              {{ scope.row.k3Delay >= 0 ? "+" : "" }}{{ scope.row.k3Delay || 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="totalDelay" label="总延误(分钟)" sortable align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.totalDelay >= 0 ? '#f56c6c' : '#67c23a' }">
              {{ scope.row.totalDelay >= 0 ? "+" : "" }}{{ scope.row.totalDelay || 0 }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getDriverDurationSummary } from "@/api";
import config from "@/config/config";
import { DateUtil } from "@/util";

export default {
  components: {},
  props: {
    value: Object
  },
  created() {
    this.query();
  },
  mounted() {},
  watch: {},
  computed: {
    ...mapState({
      size: (state) => state.btnSize,
      pathOpts: (state) => state.pathList
    })
  },
  data() {
    return {
      type: 1,

      param: {
        startDate: DateUtil.getDayStr(-30),
        endDate: DateUtil.getDayStr(0),
        pathId: config.initPath
      },
      list: []
    };
  },
  methods: {
    query() {
      getDriverDurationSummary(this.param).then((res) => {
        this.list = res.data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding: 10px;
}
</style>
